export default function ErrorsReducer(state = { error: [], showModal: false, callback: null, paymentError: null }, action) {
  switch (action.type) {
    case 'SET_ERROR':
      return {
        ...state,
        error: action.error,
        showModal: true,
        callback: action.callback,
      };
    case 'REMOVE_ERROR':
      return {
        ...state,
        error: [],
        showModal: false,
        callback: null,
      };
    case 'SET_PAYMENT_ERROR':
      return {
        ...state,
        paymentError: action.paymentError
      };
    default:
      return state;
  }
}
